module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Black.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Black.woff2
// module id = 65
// module chunks = 8